import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b017d1e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2b017d1e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b017d1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b017d1e')) {
      api.createRecord('2b017d1e', component.options)
    } else {
      api.reload('2b017d1e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2b017d1e&scoped=true", function () {
      api.rerender('2b017d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/alliance/region/index.vue"
export default component.exports